import { yupResolver } from "@hookform/resolvers/yup";
import { CSpinner } from "@coreui/react";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { useMutation } from "react-query";
import { useNavigate } from "react-router-dom";
import * as Yup from "yup";
import { useCookie } from "../../../../hooks/useCookie";
import { useToast } from "../../../../hooks/useToast";
import { general } from "../../../../locales/general";
import { taxiCouponSchema } from "../../../../rules/coupon-validation";
import apiService from "../../../../service/apiService";
import { cardStyle } from "../../../Places/PlacesTable"; // adjust path
import CreateDiscountForm from "../form/CreateDiscountForm";

type FormSchemaType = Yup.InferType<typeof taxiCouponSchema>;

export default function CreateTaxiDiscount() {
  const [isAdvanced, setIsAdvanced] = useState(false);

  const form = useForm<FormSchemaType>({
    resolver: yupResolver(taxiCouponSchema),
    defaultValues: {
      isActive: true,
      isPublic: true,
    },
  });

  const { token } = useCookie("vToken");

  const createDiscountMutation = useMutation({
    mutationFn: (data: FormSchemaType) =>
      apiService.MakePostRequest("taxi-coupons", data, token),
    mutationKey: ["taxi-coupons"],
  });

  const { toastError, toastSuccess } = useToast();
  const navigate = useNavigate();

  const changeRemisMode = (isAdvanced: boolean) => {
    // isAdvanced: true -> switch to advanced mode
    // isAdvanced: false -> switch to simple mode
    if (isAdvanced) {
      setIsAdvanced(true);
      return;
    }
    // only allowed if we have only one registration and one usage
    const discountFormData = form.getValues("discount");
    const isSimple =
      (discountFormData?.length ?? 0) <= 1 &&
      (discountFormData?.[0]?.value?.length ?? 0) <= 1;
    if (isSimple) {
      setIsAdvanced(false);
      return;
    }
    toastError("Impossible de passer du mode avancé au mode simple");
  };

  const onSubmit = (data: FormSchemaType) => {
    createDiscountMutation.mutate(data, {
      onSuccess: () => {
        toastSuccess("Coupon créé avec succès");
        navigate("/taxi/discounts");
        form.reset();
      },
      onError: () => {
        toastError(general.fr.message.operationFailed);
      },
    });
  };

  const isLoading = createDiscountMutation.isLoading;

  return (
    <div className="vz-form px-2 mt-4">
      {/* Header */}
      <div
        style={{ ...cardStyle, padding: "16px 20px" }}
        className="d-flex justify-content-between align-items-center mb-3"
      >
        <div>
          <h4 className="fs-4 fw-bold mb-0">Créer un coupon</h4>
          <div className="text-muted" style={{ fontSize: 13 }}>
            Les champs marqués d'une * sont obligatoires
          </div>
        </div>
        <button
          type="button"
          onClick={() => navigate("/taxi/discounts")}
          className="btn btn-outline-secondary rounded-pill px-3"
        >
          ← Retour
        </button>
      </div>

      <form onSubmit={form.handleSubmit(onSubmit)}>
        <section style={cardStyle} className="mb-3">
          <CreateDiscountForm
            control={form.control}
            isAdvanced={isAdvanced}
            setIsAdvanced={changeRemisMode}
          />
        </section>

        {/* Sticky actions */}
        <div
          className="d-flex justify-content-end gap-2 py-3 px-3 mt-3"
          style={{
            position: "sticky",
            bottom: 0,
            zIndex: 5,
            backgroundColor: "#fff",
            borderRadius: 16,
            boxShadow: "0 -4px 16px rgba(0,0,0,0.06)",
          }}
        >
          <button
            type="button"
            onClick={() => navigate("/taxi/discounts")}
            disabled={isLoading}
            className="btn btn-outline-secondary rounded-pill px-4"
          >
            Annuler
          </button>
          <button
            type="submit"
            disabled={isLoading}
            className="btn btn-success text-white rounded-pill px-4"
          >
            {isLoading ? <CSpinner size="sm" /> : "Créer le coupon"}
          </button>
        </div>
      </form>
    </div>
  );
}
